import { useEffect } from "react";

import { activeBeat, type BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import type { PlaybackState } from "@/lib/timeline/playback";

const LOADING_CHAPTER_KEY = "timeline-loading-chapter-v1";
const REMEMBER_MS = 1000;

export function readLoadingChapter(): string | null {
  try {
    return localStorage.getItem(LOADING_CHAPTER_KEY);
  } catch {
    return null;
  }
}

/** The next load has no bundles to ask, so note where the viewer is as they watch. */
export function useRememberLoadingChapter(
  layout: BookTimelineLayout,
  getPlayback: () => PlaybackState,
): void {
  useEffect(() => {
    const remember = (): void => {
      const chapterId = activeBeat(layout, getPlayback().playheadMs)?.chapterId;
      if (chapterId === undefined) {
        return;
      }
      try {
        localStorage.setItem(LOADING_CHAPTER_KEY, chapterId);
      } catch {
        // Private windows can refuse storage. The next load just starts from chapter 1.
      }
    };
    remember();
    const timer = window.setInterval(remember, REMEMBER_MS);
    return () => window.clearInterval(timer);
  }, [layout, getPlayback]);
}
